import { FlyoutHeader, FlyoutFooter } from "./Flyout.js";
import SmoothScroll from "./SmoothScroll.js";

am.init(() => {
    document.querySelectorAll('.aorus-header-v2').forEach(footer => new FlyoutHeader(footer));
    document.querySelectorAll('.aorus-footer-v2').forEach(footer => new FlyoutFooter(footer));
    smoothscroll();
});



    function debounce(fn, wait) {
        let timeout;

        return function () {
            let args = arguments;

            clearTimeout(timeout);

            return timeout = setTimeout(() => {

                timeout = null;
                fn.apply(self, args);

            }, wait);
        };
    }

function smoothscroll() {
    if (typeof SmoothScroll == "undefined")
        return;

    SmoothScroll({
        frameRate: 60,
        animationTime: 600,
        stepSize: 120,
        pulseAlgorithm: 1,
        pulseScale: 4,
        pulseNormalize: 1,
        accelerationDelta: 50,
        accelerationMax: 3,
        keyboardSupport: 1,
        arrowScroll: 30,
        fixedBackground: 0
    });
    let init = true;
    let resizeDebounce = debounce(resize, 150);
    am.resize(resizeDebounce);
    function resize() {
        if (window.innerWidth > 600) {
            if (!init) {
                SmoothScroll({
                    frameRate: 60,
                    animationTime: 600,
                    stepSize: 120,
                    pulseAlgorithm: 1,
                    pulseScale: 4,
                    pulseNormalize: 1,
                    accelerationDelta: 50,
                    accelerationMax: 3,
                    keyboardSupport: 1,
                    arrowScroll: 30,
                    fixedBackground: 0
                });
                init = true;
            }
        } else {
            if (init) {
                SmoothScroll.destroy();
                init = false;
            }
        }
    }
}